import { useQuery } from '@tanstack/react-query';
import { paymentService } from '../services/paymentService';
import type { PaymentListFilter } from '../types/payment';

export const ADMIN_PAYMENTS_QUERY_KEY = 'adminPayments' as const;
export const APARTMENT_SUMMARIES_QUERY_KEY = 'apartmentSummaries' as const;

/**
 * Fetches the paginated, filtered admin payments list.
 * Re-fetches whenever filter, page, or size changes.
 */
export const useAdminPayments = (
  filter: PaymentListFilter = {},
  page = 0,
  size = 20,
) =>
  useQuery({
    queryKey: [ADMIN_PAYMENTS_QUERY_KEY, filter, page, size] as const,
    queryFn: () => paymentService.getAdminPayments(filter, page, size),
  });

/**
 * Fetches the lightweight apartment summary list (ID + name) for filter controls.
 * Treated as a stable master list — stale time is intentionally long.
 */
export const useApartmentSummaries = () =>
  useQuery({
    queryKey: [APARTMENT_SUMMARIES_QUERY_KEY] as const,
    queryFn: () => paymentService.getApartmentSummaries(),
    staleTime: 5 * 60 * 1000, // 5 minutes — apartment list changes infrequently
  });
